import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames';
import { BREAKPOINTS, TOOLTIP_POSITIONS } from '../../../constants';
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';

const Tooltip = (props) => {
  const isDeviceSmallerThanTablet = !useMatchesMinWidth(BREAKPOINTS.TABLET);
  const [place, setPlace] = useState(TOOLTIP_POSITIONS.BOTTOM);

  useEffect(() => {
    function listener() {}
    if (props.smartPlacings) {
      window.addEventListener('resize', () => {
        props.smartPlacings.forEach((smartPlacing) => {
          if (window.matchMedia(smartPlacing.media).matches) {
            setPlace(smartPlacing.position);
          } else {
            setPlace(TOOLTIP_POSITIONS.BOTTOM);
          }
        });
      });
    }
    return () => {
      if (props.smartPlacings) {
        window.removeEventListener('resize', listener);
      }
    };
  }, []);

  const defaultTarget = (
    <span
      className={classNames('freedome-tooltip-hoverable', {
        'freedome-tooltip-hoverable--with-margin-left': !!props.withMarginLeft,
        'freedome-tooltip-hoverable--with-margin-right':
          !!props.withMarginRight,
      })}
    />
  );

  const tooltipTarget = props.target ? props.target : defaultTarget;
  const targetToRender = React.cloneElement(tooltipTarget, {
    'data-tip': props.text,
    'data-for': props.tooltipId,
  });

  return (
    <>
      {targetToRender}
      <ReactTooltip
        id={props.tooltipId}
        html={true}
        className={`freedome-tooltip ${
          props.classNames ? props.classNames : ''
        }`}
        place={place}
        wrapper={'span'}
        backgroundColor={'#181f36'}
        borderColor={'#181f36'}
      />
    </>
  );
};

Tooltip.propTypes = {
  text: PropTypes.string,
  withMarginLeft: PropTypes.bool,
  withMarginRight: PropTypes.bool,
  smartPlacings: PropTypes.arrayOf(
    PropTypes.shape({
      position: PropTypes.oneOf([...Object.values(TOOLTIP_POSITIONS)]),
      media: PropTypes.string.isRequired,
    })
  ),
};

export default Tooltip;
